export const FLAGS_OF_TABLE = {
	CREDIT_DEDUCTION_TABLE: 'creditDeductionTable',
	BONUS_CHARGE: 'bonus-charge',
	SAFETY_ST_VIEW: 'safety-st-view',
	SALARY_HISTORY_SLIDE: 'salaryHistorySlide',
};

export const CUSTOMER_STATUS_COLOR = {
	1: { color: '#db0715', text: 'Frozen' },
	2: { color: '#fc7514', text: 'Daptor' }
};
